module.exports = __webpack_public_path__ + "static/media/cv-react.684d6b57.jpg";